import {
    SET_WEEK_COUNT,
    SET_WEEK_START,
    GET_EVENT_ROWS,
    SET_EVENT_ROWS,
    GET_USERS,
    SET_TEMPLATE,
    GET_TEMPLATE,
    APPLY_TEMPLATE,
    SET_USER_POSITIONS,
    SET_TEMP_USER_POSITIONS,
    GET_JOBPACKS
} from "./types";

import {
    selectPreviousWeekStart,
    selectNextWeekStart,
    selectEventRows,
    selectWeekStartKey,
    selectTemplate,
    selectUserNames,
    selectUserPositions,
    selectTempUserPositions
} from "./selectors";

import firebase from "firebase/app";
export const setWeekCount = (weekCount = false) => {
    return dispatch => {
        if (!weekCount) return;
        dispatch({ type: SET_WEEK_COUNT, payload: weekCount });
    };
};

export const incrementWeekStart = () => {
    return (dispatch, getStore) => {
        const store = getStore();
        let weekStart = selectNextWeekStart(store);
        dispatch({ type: SET_WEEK_START, payload: weekStart });
        dispatch(getEventRows());
    };
};

export const decrementWeekStart = () => {
    return (dispatch, getStore) => {
        const store = getStore();
        let weekStart = selectPreviousWeekStart(store);
        dispatch({ type: SET_WEEK_START, payload: weekStart });
        dispatch(getEventRows());
    };
};

export const setEventRowTitle = (title, rowIndex) => {
    return (dispatch, getStore) => {
        const store = getStore();
        let eventRows = selectEventRows(store);

        if (eventRows === false) {
            eventRows = [];
        }

        eventRows[rowIndex].title = title;

        dispatch(setEventRows(eventRows));
    };
};

export const addEventRow = () => {
    return (dispatch, getStore) => {
        const store = getStore();
        let eventRows = selectEventRows(store);

        if (eventRows === false) {
            eventRows = [];
        }

        eventRows.push({
            title: "Untitled",
            events: {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false
            }
        });

        dispatch(setEventRows(eventRows));
    };
};

export const deleteEventRow = (index = false) => {
    return (dispatch, getStore) => {
        if (!index) {
            dispatch({
                type: SET_EVENT_ROWS.FAIL
            });
        }
        const store = getStore();
        let eventRows = selectEventRows(store);

        if (eventRows === false) {
            eventRows = [];
        } else {
            eventRows.splice(index, 1);
        }

        dispatch(setEventRows(eventRows));
    };
};

export const applyTemplate = () => {
    return (dispatch, getStore) => {
        dispatch({ type: SET_TEMPLATE.REQUEST });
        const store = getStore();
        const weekStart = selectWeekStartKey(store);
        const template = selectTemplate(store);
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                dispatch({
                    type: APPLY_TEMPLATE.FAIL
                });
            } else {
                firebase
                    .database()
                    .ref(`/dashboard/weekly_planner/event_rows/${weekStart}`)
                    .set(template, error => {
                        if (error === null) {
                            dispatch({
                                type: APPLY_TEMPLATE.SUCCESS
                            });
                        } else {
                            dispatch({
                                type: APPLY_TEMPLATE.FAIL
                            });
                        }
                    });
            }
        });
    };
};

export const setTemplate = () => {
    return (dispatch, getStore) => {
        dispatch({ type: SET_TEMPLATE.REQUEST });
        const store = getStore();
        const template = selectEventRows(store);
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                dispatch({
                    type: SET_TEMPLATE.FAIL
                });
            } else {
                firebase
                    .database()
                    .ref(`/dashboard/weekly_planner/template`)
                    .set(template, error => {
                        if (error !== null) {
                            dispatch({
                                type: SET_TEMPLATE.SUCCESS
                            });
                        } else {
                            dispatch({
                                type: SET_TEMPLATE.FAIL
                            });
                        }
                    });
            }
        });
    };
};

export const getTemplate = () => {
    return dispatch => {
        dispatch({ type: GET_TEMPLATE.REQUEST });
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                dispatch({
                    type: GET_TEMPLATE.FAIL
                });
            } else {
                firebase
                    .database()
                    .ref(`/dashboard/weekly_planner/template`)
                    .on("value", snapshot => {
                        if (snapshot.val() === null) {
                            dispatch({
                                type: GET_TEMPLATE.FAIL
                            });
                        } else {
                            dispatch({
                                type: GET_TEMPLATE.SUCCESS,
                                payload: snapshot.val()
                            });
                        }
                    });
            }
        });
    };
};

export const getEventRows = () => {
    return (dispatch, getStore) => {
        dispatch({ type: GET_EVENT_ROWS.REQUEST });
        const store = getStore();
        const weekStart = selectWeekStartKey(store);
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                dispatch({
                    type: GET_EVENT_ROWS.FAIL
                });
            } else {
                firebase
                    .database()
                    .ref(`/dashboard/weekly_planner/event_rows/${weekStart}`)
                    .on("value", snapshot => {
                        if (snapshot.val() === null) {
                            dispatch({
                                type: GET_EVENT_ROWS.FAIL
                            });
                        } else {
                            dispatch({
                                type: GET_EVENT_ROWS.SUCCESS,
                                payload: snapshot.val()
                            });

                            dispatch(setUserPositions(snapshot.val()));
                        }
                    });
            }
        });
    };
};

const setUserPositions = (eventRows = false) => {
    return (dispatch, getStore) => {
        if (eventRows === false) {
            return false;
        }
        const userPositions = [];
        const store = getStore();
        const userNames = selectUserNames(store).reduce((acc, curr) => {
            acc[curr] = false;
            return acc;
        }, {});

        for (let day = 0; day < 7; ++day) {
            userPositions.push(JSON.parse(JSON.stringify(userNames)));
            for (let row = 0; row < eventRows.length; ++row) {
                const currentRow = eventRows[row];
                const currentDay = currentRow.events[day];

                if (currentDay !== false) {
                    Object.keys(userNames).map(name => {
                        const keys = Object.keys(currentDay);
                        const index = Object.values(currentDay).findIndex(
                            e => e === name
                        );
                        if (index !== -1) {
                            userPositions[day][name] = {
                                row,
                                key: keys[index]
                            };
                        }
                        return null;
                    });
                }
            }
        }

        dispatch({ type: SET_USER_POSITIONS, payload: userPositions });
    };
};

export const clearTempUserPosition = (day = false) => {
    return (dispatch, getStore) => {
        if (day === false) {
            return false;
        }
        const store = getStore();
        const tempUserPositions = JSON.parse(
            JSON.stringify(selectTempUserPositions(store))
        );
        const tempUserPositionsForDay = tempUserPositions[day];

        Object.keys(tempUserPositionsForDay).map(e => {
            tempUserPositionsForDay[e] = false;
            return e;
        });

        tempUserPositions[day] = tempUserPositionsForDay;
        dispatch({
            type: SET_TEMP_USER_POSITIONS,
            payload: [...tempUserPositions]
        });
    };
};
export const setTempUserPosition = (
    day = false,
    row = false,
    user = false,
    key = false
) => {
    return (dispatch, getStore) => {
        if (day === false || row === false || user === false || key === false) {
            return false;
        }
        const store = getStore();
        const tempUserPositions = JSON.parse(
            JSON.stringify(selectTempUserPositions(store))
        );
        const tempUserPositionsForDay = tempUserPositions[day];

        if (user === "") {
            Object.keys(tempUserPositionsForDay).map(e => {
                const user = tempUserPositionsForDay[e];
                if (user.key === key) {
                    tempUserPositionsForDay[e] = false;
                    tempUserPositions[day] = tempUserPositionsForDay;
                    dispatch({
                        type: SET_TEMP_USER_POSITIONS,
                        payload: [...tempUserPositions]
                    });
                }
                return null;
            });
        } else {
            tempUserPositionsForDay[user] = {
                row,
                key
            };
            tempUserPositions[day] = tempUserPositionsForDay;
            dispatch({
                type: SET_TEMP_USER_POSITIONS,
                payload: [...tempUserPositions]
            });
        }
    };
};

export const copyUserPositionsToTempUserPositions = () => {
    return (dispatch, getStore) => {
        const store = getStore();
        const userPositions = selectUserPositions(store);

        dispatch({
            type: SET_TEMP_USER_POSITIONS,
            payload: [...userPositions]
        });
    };
};

export const getUsers = () => {
    return dispatch => {
        dispatch({ type: GET_USERS.REQUEST });

        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                dispatch({
                    type: GET_USERS.FAIL
                });
            } else {
                firebase
                    .database()
                    .ref(`/users`)
                    .on("value", snapshot => {
                        dispatch({
                            type: GET_USERS.SUCCESS,
                            payload: snapshot.val()
                        });
                    });
            }
        });
    };
};

export const setDayData = (
    rowIndex = false,
    dayIndex = false,
    data = false
) => {
    return (dispatch, getStore) => {
        if (rowIndex === false || dayIndex === false || data === false) {
            dispatch({
                type: SET_EVENT_ROWS.FAIL
            });
        }
        const store = getStore();
        let eventRows = selectEventRows(store);
        eventRows[rowIndex]["events"][dayIndex] = data;

        dispatch(setEventRows(eventRows));
    };
};

export const setEventRows = (eventRows = false) => {
    return (dispatch, getStore) => {
        if (eventRows === false) {
            dispatch({
                type: SET_EVENT_ROWS.FAIL
            });
        }
        dispatch({
            type: SET_EVENT_ROWS.REQUEST
        });
        const store = getStore();
        const weekStart = selectWeekStartKey(store);
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                dispatch({
                    type: SET_EVENT_ROWS.FAIL
                });
            } else {
                firebase
                    .database()
                    .ref(`/dashboard/weekly_planner/event_rows/${weekStart}`)
                    .set(eventRows, error => {
                        if (error === null) {
                            dispatch({
                                type: SET_EVENT_ROWS.SUCCESS
                            });
                        } else {
                            dispatch({
                                type: SET_EVENT_ROWS.FAIL
                            });
                        }
                    });
            }
        });
    };
};

export const getJobpacks = () => {
    return dispatch => {
        dispatch({
            type: GET_JOBPACKS.REQUEST
        });
        firebase.auth().onAuthStateChanged(user => {
            if (user === null) {
                dispatch({
                    type: GET_JOBPACKS.FAIL
                });
            } else {
                firebase
                    .database()
                    .ref(`/subjects/job_packs`)
                    .on("value", snapshot => {
                        dispatch({
                            type: GET_JOBPACKS.SUCCESS,
                            payload: snapshot.val()
                        });
                    });
            }
        });
    };
};
